// import { Notifier } from '@airbrake/browser';

export const google = {
  API_KEY: '',
  CLIENT_ID: '',
  SECRET: '',
};

export const facebook = {
  APP_ID: '',
};

let AIRBRAKE_NOTIFIER = null;
// if (process.env.NODE_ENV === 'production') {
//   AIRBRAKE_NOTIFIER = new Notifier({
//     projectId: 417105,
//     projectKey: '9e24f197d52385f35ff1d4b966f5c788',
//     environment: process.env.NODE_ENV,
//   });
// }

export const WHITE_LABELED_PRODUCT_NAMES = {
  INSURANCE_IO: "Insuranceio",
  USHA_IO: "Ushaio",
  INSURANCEAGENTS_AI: "Insuranceagentsai",
  GOAL: "Goal",
  SFPRO: "Sfpro",
  SMARTFINANCIALPRO: "Smartfinancialpro",
  BENEPATH: "Benepath",
  SMARTHUB: "Smarthub",
};

const productFavColor = {
  INSURANCE_IO: "#e73989",
  USHA_IO: "#DB0037",
  INSURANCEAGENTS_AI: "#308ed6",
  GOAL: "#057be5",
  SFPRO: "#e73989",
  BENEPATH: "#E67917",
  SMARTHUB: "#e73989",
};

let selectedProductName = null;

for (const key in WHITE_LABELED_PRODUCT_NAMES) {
  if (WHITE_LABELED_PRODUCT_NAMES[key] === process.env.REACT_APP_PRODUCT_NAME) {
    selectedProductName = key;
    break;
  }
}

export const PRODUCT_FAV_COLOR = selectedProductName ? productFavColor[selectedProductName] : null;

export const AppConfiguration = {
  WEBSITE: process.env.REACT_APP_WEBSITE || 'Insurance.io',
  PRODUCT_NAME: process.env.REACT_APP_PRODUCT_NAME || 'Insuranceio',
  INFO_MAIL: process.env.REACT_APP_INFO_MAIL || 'info@insurance.io',
  STATIC_CALLER_ID: process.env.REACT_APP_STATIC_CALLER_ID || '669-279-3623',
  DEFAULT_AUTH: process.env.REACT_APP_DEFAULTAUTH,
  STRIPE_REDIRECT_ROOT: 'https://smart-financial-aws.netlify.app/',
  INVITE_ADMIN_INTERNAL_USERS: (process.env.REACT_APP_INVITE_ADMIN_INTERNAL_USERS || "smartfinancial.com ikshalabs.com").split(" "),
  REACT_CLIENT_HOST_SUBDOMAIN: process.env.REACT_APP_CLIENT_HOST_SUBDOMAIN || "www",
  REACT_ADMIN_HOST_SUBDOMAIN: process.env.REACT_APP_ADMIN_HOST_SUBDOMAIN || "admin",
  REACT_QUOTES_HOST_SUBDOMAIN: process.env.REACT_APP_QUOTES_HOST_SUBDOMAIN || "quotes",
  PRODUCT_FAV_COLOR: PRODUCT_FAV_COLOR,
  //STRIPE_REDIRECT_ROOT: "http://localhost:3000/",
  BACKEND_URL:
    process.env.REACT_APP_BACKEND_URL ||
    //"https://api.ad-portal.smartfinancial.com",
    "https://api-stage.ad-portal.smartfinancial.com",
  AIRBRAKE_NOTIFIER,
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    'pk_test_51LGoHXSAsqPgOP4BVbgtM8NTlBbVJkWQDFlOpAzvXfBdeDvDlddCVxazw34fvwAg3HfTMDyxWZxnX8qxjcgR9R1A000XG8VZQm',
  WHITE_LABELING_CONTACT_PHONE: process.env.REACT_APP_WHITE_LABELING_CONTACT_PHONE || '877-323-7750',
  CONSENT_BACKEND_URL: (process.env.REACT_APP_CONSENT_BACKEND_URL || 'http://localhost:8080'),
  CONSENT_EVENT_BACKEND_URL: (process.env.REACT_APP_CONSENT_EVENT_BACKEND_URL || 'http://localhost:8001'),
  CONSENT_REPLAYER_URL: (process.env.REACT_APP_CONSENT_REPLAYER_URL || 'http://localhost:3002'),
  CONSENT_SCRIPT_URL: (process.env.REACT_APP_CONSENT_SCRIPT_URL || 'http://localhost:8000/dist/bundle.js'),
  CONSENT_API_TOKEN: (process.env.REACT_APP_CONSENT_API_TOKEN || 'abc'),
  DS_APP_URL: (process.env.REACT_APP_DS_APP_URL || 'XXXXXXXXXXXXXXXXXXXXX'),
  IS_RTB_BRAND: process.env.REACT_APP_IS_RTB_BRAND === 'true' ? true : false
};

export const isInsuranceioBrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.INSURANCE_IO
export const isUshaBrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.USHA_IO
export const isIABrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.INSURANCEAGENTS_AI
export const isGoalBrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.GOAL
export const isSfproBrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.SFPRO
export const isBenepathBrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.BENEPATH
export const isSmarthubBrand = AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.SMARTHUB
export const isRtbBrand = AppConfiguration.IS_RTB_BRAND
